<div class="ui-g-12" *ngIf="renderView">
  <div class="ui-g-12">
    <div class="ui-g-6 ui-sm-12">
      <h2>
        Invoicing and Billing Information
        <span *ngIf="isVmeMode && currentOrgName"><i>for</i> {{ currentOrgName }}</span>
      </h2>
    </div>
    <div class="ui-g-4 pull-left m-t-10 ui-sm-12" *ngIf="isVmeMode && !invoiceAddressId">
      <organisation-select-list
        [minTextLength]="1"
        [selectPlaceHolderText]="'Type to set organisation'"
        *ngIf="isVmeMode"
        (valueChange)="onOrganisationChange($event)"
      ></organisation-select-list>
    </div>
  </div>
  <form
    [formGroup]="invoiceAddressFormGroup"
    (ngSubmit)="save(invoiceAddressFormGroup.value)"
    autocomplete="off"
  >
    <!-- INVOICE ADDRESS Make readonly as thi-->
    <div class="ui-grid-row">
      <p-fieldset legend="Invoice Address">
        <div class="ui-g-6 ui-md-6 ui-lg-6 ui-sm-12">
          <div class="ui-g-12">
            <div class="ui-grid-col-4">
              <label for="invoiceCompanyName">Invoice Company Name</label>
            </div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="invoiceCompanyName"
                formControlName="invoiceCompanyName"
                tabindex="1"
                maxlength="100"
                class="form-component"
              />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-grid-col-4">
              <label for="invoiceContactFirstName">Invoice Contact First Name</label>
            </div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="invoiceContactFirstName"
                formControlName="invoiceContactFirstName"
                tabindex="2"
                maxlength="35"
                class="form-component"
              />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-grid-col-4">
              <label for="invoiceContactLastName">Invoice Contact Last Name</label>
            </div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="invoiceContactLastName"
                formControlName="invoiceContactLastName"
                tabindex="3"
                maxlength="35"
                class="form-component"
              />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-grid-col-4">
              <label for="invoiceContactEmail">Invoice Contact Email</label>
            </div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="invoiceContactEmail"
                formControlName="invoiceContactEmail"
                tabindex="4"
                maxlength="254"
                class="form-component"
              />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-grid-col-4">
              <label for="invoiceContactPhone">Invoice Contact Phone</label>
            </div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="invoiceContactPhone"
                formControlName="invoiceContactPhone"
                tabindex="5"
                maxlength="20"
                class="form-component"
              />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-grid-col-4">
              <label for="invoiceContact2FirstName">Invoice Contact 2 First Name</label>
            </div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="invoiceContact2FirstName"
                formControlName="invoiceContact2FirstName"
                tabindex="6"
                maxlength="35"
                class="form-component"
              />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-grid-col-4">
              <label for="invoiceContact2LastName">Invoice Contact 2 Last Name</label>
            </div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="invoiceContact2LastName"
                formControlName="invoiceContact2LastName"
                tabindex="7"
                maxlength="35"
                class="form-component"
              />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-grid-col-4">
              <label for="invoiceContact2Email">Invoice Contact 2 Email</label>
            </div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="invoiceContact2Email"
                formControlName="invoiceContact2Email"
                tabindex="8"
                maxlength="254"
                class="form-component"
              />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-grid-col-4">
              <label for="invoiceContact3FirstName">Invoice Contact 3 First Name</label>
            </div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="invoiceContact3FirstName"
                formControlName="invoiceContact3FirstName"
                tabindex="9"
                maxlength="35"
                class="form-component"
              />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-grid-col-4">
              <label for="invoiceContact3LastName">Invoice Contact 3 Last Name</label>
            </div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="invoiceContact3LastName"
                formControlName="invoiceContact3LastName"
                tabindex="10"
                maxlength="35"
                class="form-component"
              />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-grid-col-4">
              <label for="invoiceContact3Email">Invoice Contact 3 Email</label>
            </div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="invoiceContact3Email"
                formControlName="invoiceContact3Email"
                tabindex="11"
                maxlength="35"
                class="form-component"
              />
            </div>
          </div>
        </div>
        <div class="ui-g-6 ui-md-6 ui-lg-6 ui-sm-12">
          <div class="ui-g-12">
            <div class="ui-grid-col-4">
              <label for="invoice_addressLine1">Address Line 1</label>
            </div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="invoice_addressLine1"
                formControlName="addressLine1"
                tabindex="12"
                maxlength="60"
                class="form-component"
              />
            </div>
          </div>

          <div class="ui-g-12">
            <div class="ui-grid-col-4">
              <label for="invoice_addressLine1">Address Line 2</label>
            </div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="invoice_addressLine2"
                formControlName="addressLine2"
                tabindex="13"
                maxlength="60"
                class="form-component"
              />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-grid-col-4">
              <label for="invoice_addressLine1">Address Line 3</label>
            </div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="invoice_addressLine3"
                formControlName="addressLine3"
                tabindex="14"
                maxlength="60"
                class="form-component"
              />
            </div>
          </div>

          <div class="ui-g-12">
            <div class="ui-grid-col-4"><label for="invoice_addressLine1">Town</label></div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="invoice_town"
                formControlName="town"
                tabindex="15"
                maxlength="35"
                class="form-component"
              />
            </div>
          </div>

          <div class="ui-g-12">
            <div class="ui-grid-col-4"><label for="invoice_postcode">Post Code</label></div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="invoice_postcode"
                formControlName="postCode"
                tabindex="16"
                maxlength="8"
                class="form-component"
              />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-grid-col-4"><label for="country">Country</label></div>
            <div class="ui-grid-col-8">
              <p-dropdown
                [options]="countries"
                formControlName="country"
                autoWidth="false"
                styleClass="form-component"
                tabindex="17"
              >
              </p-dropdown>
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-grid-col-4">
              <label for="purchaseOrderNumber">Purchase Order Number</label>
            </div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="purchaseOrderNumber"
                formControlName="purchaseOrderNumber"
                tabindex="18"
                maxlength="100"
                class="form-component"
              />
            </div>
          </div>
        </div>
      </p-fieldset>
    </div>

    <!-- BILLING -->
    <div *ngIf="isVmeMode">
      <p-fieldset legend="Billing">
        <div class="ui-grid-row">
          <div class="ui-g-6 ui-sm-12">
            <div class="ui-grid-col-4">
              <label for="invoicePeriod">Invoice Period (days, or 0 for monthly)</label>
            </div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="invoicePeriod"
                formControlName="invoicePeriod"
                tabindex="19"
                (keydown)="inputHelper.allowNumberInputKey($event, false)"
                maxlength="2"
                class="form-component"
              />
            </div>
          </div>
          <div class="ui-g-6 ui-sm-12">
            <div class="ui-grid-col-4">
              <label for="paymentTermsType">Xero Payment Terms Type</label>
            </div>
            <div class="ui-grid-col-8">
              <p-dropdown
                [options]="paymentTermsTypes"
                formControlName="paymentTermsType"
                autoWidth="false"
                styleClass="form-component"
                tabindex="20"
              >
              </p-dropdown>
            </div>
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-g-6 ui-sm-12">
            <div class="ui-grid-col-4">
              <label for="paymentTermsDays">Xero Payment Terms Days</label>
            </div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="paymentTermsDays"
                (keydown)="inputHelper.allowNumberInputKey($event, false)"
                formControlName="paymentTermsDays"
                tabindex="21"
                maxlength="3"
                class="form-component"
              />
            </div>
          </div>
          <div class="ui-g-6 ui-sm-12">
            <div class="ui-grid-col-4"><label for="">Xero Contact ID</label></div>
            <div class="ui-grid-col-8">
              {{
                customerdata && customerdata.invoiceAddress
                  ? customerdata.invoiceAddress.xeroContactId
                  : ''
              }}
            </div>
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-g-6 ui-sm-12">
            <div class="ui-grid-col-4"><label for="">Xero Contact Updated On</label></div>
            <div class="ui-grid-col-8">
              {{
                customerdata && customerdata.invoiceAddress
                  ? (customerdata.invoiceAddress.xeroContactUpdatedOn | datex : 'DD MMM YYYY HH:mm')
                  : ''
              }}
            </div>
          </div>
          <div class="ui-g-6 ui-sm-12">
            <div class="ui-grid-col-4"><label for="">Revolut Counterparty ID</label></div>
            <div class="ui-grid-col-8">
              {{
                customerdata && customerdata.invoiceAddress
                  ? customerdata.invoiceAddress.revolutCounterpartyId
                  : ''
              }}
            </div>
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-g-6 ui-sm-12">
            <div class="ui-grid-col-4"><label for="">Revolut Counterparty Updated On</label></div>
            <div class="ui-grid-col-8">
              {{
                customerdata && customerdata.invoiceAddress
                  ? (customerdata.invoiceAddress.revolutLastUpdated | datex : 'DD MMM YYYY HH:mm')
                  : ''
              }}
            </div>
          </div>
          <div class="ui-g-6 ui-sm-12">
            <div class="ui-grid-col-4"><label for="billingWaitDays">Billing Wait Days</label></div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="billingWaitDays"
                formControlName="billingWaitDays"
                tabindex="22"
                (keydown)="inputHelper.allowNumberInputKey($event, false)"
                maxlength="2"
                class="form-component"
              />
            </div>
          </div>
        </div>
        <div class="ui-grid-row">
          <div
            class="ui-g-6 ui-sm-12"
            *ngIf="selectOrganisationType == 2 || selectOrganisationType == 4"
          >
            <div class="ui-grid-col-4">
              <label for="">Add Transaction Fee to Transaction Line</label>
            </div>
            <div class="ui-grid-col-8">
              <p-checkbox
                binary="true"
                name="isAddTransactionFee"
                [formControl]="newCustomerForm.controls['isAddTransactionFee']"
              ></p-checkbox>
            </div>
          </div>
        </div>
      </p-fieldset>
    </div>
    <p></p>
    <div class="ui-g pull-right">
      <div>
        <button type="submit" pButton label="Cancel" (click)="cancelOperation($event)"></button>
        <button
          type="submit"
          class="ui-button-success"
          pButton
          [disabled]="invoiceAddressFormGroup.invalid || isSaving"
          label="Save"
          icon="pi pi-save"
        ></button>
      </div>
    </div>
    <input type="hidden" name="organisationId" formControlName="organisationId" />
  </form>
</div>
